/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetReferredProviderErrorResponse,
  GetReferredProviderParams,
  GetReferredProviderResponse,
} from './api.schemas';

import { api } from '../util/http';

export const getReferredProvider = (params?: GetReferredProviderParams, signal?: AbortSignal) => {
  return api<GetReferredProviderResponse>({
    url: `/api/referred-provider`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetReferredProviderQueryKey = (params?: GetReferredProviderParams) => {
  return [`/api/referred-provider`, ...(params ? [params] : [])] as const;
};

export const getGetReferredProviderQueryOptions = <
  TData = Awaited<ReturnType<typeof getReferredProvider>>,
  TError = GetReferredProviderErrorResponse,
>(
  params?: GetReferredProviderParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReferredProvider>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReferredProviderQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReferredProvider>>> = ({ signal }) =>
    getReferredProvider(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReferredProvider>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReferredProviderQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReferredProvider>>
>;
export type GetReferredProviderQueryError = GetReferredProviderErrorResponse;

export function useGetReferredProvider<
  TData = Awaited<ReturnType<typeof getReferredProvider>>,
  TError = GetReferredProviderErrorResponse,
>(
  params: undefined | GetReferredProviderParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReferredProvider>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferredProvider>>,
          TError,
          Awaited<ReturnType<typeof getReferredProvider>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReferredProvider<
  TData = Awaited<ReturnType<typeof getReferredProvider>>,
  TError = GetReferredProviderErrorResponse,
>(
  params?: GetReferredProviderParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReferredProvider>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferredProvider>>,
          TError,
          Awaited<ReturnType<typeof getReferredProvider>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReferredProvider<
  TData = Awaited<ReturnType<typeof getReferredProvider>>,
  TError = GetReferredProviderErrorResponse,
>(
  params?: GetReferredProviderParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReferredProvider>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetReferredProvider<
  TData = Awaited<ReturnType<typeof getReferredProvider>>,
  TError = GetReferredProviderErrorResponse,
>(
  params?: GetReferredProviderParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReferredProvider>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReferredProviderQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
